import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksServicePayments(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].getRegulationsStagesPlanWorksServicePayments,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksServicePaymentPreview(companyId, regulationId, stageId, planWorkId, servicePaymentId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].getRegulationsStagesPlanWorksServicePaymentPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				servicePaymentId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksServicePaymentPopup(companyId, regulationId, stageId, planWorkId, servicePaymentId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].getRegulationsStagesPlanWorksServicePaymentPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				servicePaymentId,
			},
		},
	)
}

function createRegulationsStagesPlanWorksServicePayment(companyId, regulationId, stageId, planWorkId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].createRegulationsStagesPlanWorksServicePayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
		...data,
	})
}

function getRegulationsStagesPlanWorksServicePayment(companyId, regulationId, stageId, planWorkId, servicePaymentId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].getRegulationsStagesPlanWorksServicePayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			servicePaymentId,
		},
	})
}

function patchRegulationsStagesPlanWorksServicePayment(companyId, regulationId, stageId, planWorkId, servicePaymentId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].patchRegulationsStagesPlanWorksServicePayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			servicePaymentId,
		},
		...data,
	})
}

function putRegulationsStagesPlanWorksServicePayment(companyId, regulationId, stageId, planWorkId, servicePaymentId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].putRegulationsStagesPlanWorksServicePayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			servicePaymentId,
		},
		...data,
	})
}

function deleteRegulationsStagesPlanWorksServicePayment(companyId, regulationId, stageId, planWorkId, servicePaymentId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS].deleteRegulationsStagesPlanWorksServicePayment, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			servicePaymentId,
		},
	})
}

export default {
	getRegulationsStagesPlanWorksServicePayments,
	getRegulationsStagesPlanWorksServicePaymentPopup,
	getRegulationsStagesPlanWorksServicePaymentPreview,
	getRegulationsStagesPlanWorksServicePayment,
	patchRegulationsStagesPlanWorksServicePayment,
	putRegulationsStagesPlanWorksServicePayment,
	createRegulationsStagesPlanWorksServicePayment,
	deleteRegulationsStagesPlanWorksServicePayment,
}
